import { FC } from "react";
import { Divider, Typography } from "@mui/material";

interface FormTituloProps {
  titulo: string;
  // Ação do formulário ("Novo", "Editar", "Visualizar")
  acao?: string;
  complemento?: string;
}

const rotulosAcao: Record<string, string> = { Novo: "Incluir" };

// Título exibido dentro do card do formulário (mesmo padrão do XC WMS)
const FormTitulo: FC<FormTituloProps> = ({ titulo, acao, complemento }) => {
  const texto = [titulo, acao && (rotulosAcao[acao] ?? acao)]
    .filter(Boolean)
    .join(" / ");

  return (
    <>
      <Typography mt={1} pb={1} paddingLeft={2}>
        {texto}
        {complemento && ` ${complemento}`}
      </Typography>
      <Divider />
    </>
  );
};

export default FormTitulo;
